// Pagamentos do card animado do hero. Exemplo ilustrativo: nomes e valores
// fictícios, sem relação com cliente real — o card diz isso na tela.

export type HeroPayment = {
  customer: string;
  detail: string;
  amount: number;
};

export const HERO_PAYMENTS_START_TOTAL = 18432.7;

export const HERO_PAYMENTS: HeroPayment[] = [
  { customer: "Juliana S.", detail: "parcela 3 de 6 paga", amount: 189.9 },
  { customer: "Carlos M.", detail: "acordo quitado via Pix", amount: 412.5 },
  { customer: "Fernanda L.", detail: "parcela 2 de 4 paga", amount: 129.9 },
  { customer: "Roberto F.", detail: "parcela atrasada paga", amount: 254.3 },
  { customer: "Ana Paula R.", detail: "parcela 5 de 10 paga", amount: 98.7 },
  { customer: "Marcos T.", detail: "acordo quitado via Pix", amount: 337.4 },
];

export const formatBRL = (value: number) =>
  value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
